export default __webpack_public_path__ + "static/096-d73c52132223eeff2bda69f86f2f766f.jpg";